import * as Types from '../constants/Types';

export const dataAllPropertyAction = () => ({type: Types.TOUR_PROPERTY_LIST_ALL_ACTION});
export const dataAllPropertySuccess = (allProperties) => ({type: Types.TOUR_PROPERTY_LIST_ALL_SUCCESS, allProperties});

export const dataPropertyAction = (filters) => ({type: Types.TOUR_PROPERTY_LIST_ACTION, filters});
export const dataPropertySuccess = (properties) => ({type: Types.TOUR_PROPERTY_LIST_SUCCESS, properties});

export const dataPropertyLoadAllAction = (filters) => ({type: Types.PROPERTY_LIST_LOAD_ALL_ACTION, filters});
export const dataPropertyLoadAllSuccess = (properties) => ({type: Types.PROPERTY_LIST_LOAD_ALL_SUCCESS, properties});

export const createPropertyAction = (params) => ({type: Types.TOUR_PROPERTY_CREATE_ACTION, params});
export const deletePropertyAction = (params) => ({type: Types.TOUR_PROPERTY_DELETE_ACTION, params});

export const getUpdatePropertyAction = (params) => ({type: Types.TOUR_PROPERTY_GET_UPDATE_ACTION, params});
export const getUpdatePropertySuccess = (dataUpdate) => ({type: Types.TOUR_PROPERTY_GET_UPDATE_SUCCESS, dataUpdate});

export const updatePropertyAction = (params) => ({type: Types.TOUR_PROPERTY_UPDATE_ACTION, params});

export const createPropertyTranslate = (property) => ({type: Types.TOUR_PROPERTY_CREATE_TRANSLATE_ACTION, property});
export const updatePropertyTranslate = (property) => ({type: Types.TOUR_PROPERTY_UPDATE_TRANSLATE_ACTION, property});
export const deletePropertyTranslate = (property, refreshParams) => ({type: Types.TOUR_PROPERTY_DELETE_TRANSLATE_ACTION, property, refreshParams});
